import "../scss/main.scss";

import { initAccessCodeMask } from "./accessCodeLogin.js";
import { initExpandables } from "./expand.js";
import { initMobileMenu } from "./mobileMenu.js";
import { initSimplifiedCart } from "./simplifiedCart.js";
import { initWelcomeModal } from "./welcomeModal.js";

// The bundle is loaded at the end of <body>, so the markup is already parsed.
// Every page gets the same bundle; each widget bails out where its markup is
// absent.
initAccessCodeMask();
initExpandables();
initMobileMenu();
initSimplifiedCart();
initWelcomeModal();
